import { render, staticRenderFns } from "./StockActivityValuation.vue?vue&type=template&id=80dfddf2&"
import script from "./StockActivityValuation.vue?vue&type=script&lang=js&"
export * from "./StockActivityValuation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports